import { Colors } from './colors';

export const WEIGHT_MIN_VALUE = 0;
export const WEIGHT_MAX_VALUE = 160;
export const WEIGHT_INITIAL_VALUE = WEIGHT_MAX_VALUE / 2;
export const WEIGHT_DEFAULT_COLOR = Colors.FRENCH_VIOLET;
export const WEIGHT_FRACTION_DIGITS = 0;

export const HEIGHT_DEFAULT_CONTINUER_FACTOR = 0.6;
export const HEIGHT_DEFAULT_CONTENT_FACTOR = 0.55;
export const HEIGHT_DEFAULT_CONTAINER_DIFF =
  HEIGHT_DEFAULT_CONTINUER_FACTOR - HEIGHT_DEFAULT_CONTENT_FACTOR;
export const HEIGHT_MIN_VALUE = 40;
export const HEIGHT_MAX_VALUE = 240;
export const HEIGHT_INITIAL_VALUE = HEIGHT_MAX_VALUE / 2;
export const HEIGHT_DEFAULT_STEP = 10;
export const HEIGHT_DEFAULT_SECTION_SIZE = 6;
export const HEIGHT_FRACTION_DIGITS = 0;
